import React, { useCallback, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { Breakpoints, useMediaQuery } from '@/hooks/useMediaQuery';

import { ROUTES } from '@/router/baseRoutes';

import { HeaderWithGoBackButton, HeaderWithGoBackButtonProps } from './HeaderWithGoBackButton';

export const HeaderWithHomeLinkButton = React.memo<Pick<HeaderWithGoBackButtonProps, 'header' | 'className'>>(
  function (props) {
    const navigate = useNavigate();
    const { state } = useLocation();
    const goBackRef = useRef(state?.from);
    const isMobileSize = useMediaQuery(Breakpoints.SM);

    const onGoBack = useCallback(() => {
      if (state?.continueGercPayment) {
        navigate(ROUTES.INTERNAL_SERVICES);
      } else {
        navigate(goBackRef.current ? goBackRef.current : -1);
      }
    }, [navigate, state]);

    return (
      <HeaderWithGoBackButton
        {...props}
        goBackText={isMobileSize ? 'Назад' : 'Повернутись до списку послуг'}
        onGoBack={onGoBack}
      />
    );
  },
);
